import { useTranslation } from "react-i18next";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import BooleanStatsPanel from "./BooleanStatsPanel";
import NumericStatsPanel from "./NumericStatsPanel";

export default function Bloc7BlockSection({
  id,
  title,
  description,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const boolStats = itemsByField["bloc7.waterBool"]?.stats || null;
  const sourceStats = itemsByField["bloc7.waterSource"]?.stats || null;
  const tempStats = itemsByField["bloc7.waterTemperature"]?.stats || null;
  const phStats = itemsByField["bloc7.waterPH"]?.stats || null;

  const boolChartItems = [
    { category: t("common.yes", "Sí"), count: boolStats?.yes || 0 },
    { category: t("common.no", "No"), count: boolStats?.no || 0 },
  ];
  const sourceChartItems = (sourceStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));
  const tempBins = (tempStats?.bins || []).map((bin) => ({
    category: bin.label,
    count: bin.count,
  }));
  const phBins = (phStats?.bins || []).map((bin) => ({
    category: bin.label,
    count: bin.count,
  }));

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc7.loading", "Carregant estadístiques de bloc7…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <BooleanStatsPanel
            title={t("dashboard.blocks.bloc7.waterPresence", "Presència d’aigua")}
            stats={boolStats}
          />
          <NumericStatsPanel
            title={t(
              "dashboard.blocks.bloc7.waterTemperature",
              "Temperatura de l’aigua"
            )}
            stats={tempStats}
          />
          <NumericStatsPanel
            title={t("dashboard.blocks.bloc7.waterPh", "pH de l’aigua")}
            stats={phStats}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc7.yesNoWater",
              "Respostes sí/no sobre aigua"
            )}
            items={boolChartItems}
          />
          <BarPlot
            title={t("dashboard.blocks.bloc7.waterSource", "Procedència de l’aigua")}
            items={sourceChartItems}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc7.waterTemperatureDistribution",
              "Distribució de temperatura de l’aigua"
            )}
            items={tempBins}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc7.waterPhDistribution",
              "Distribució de pH de l’aigua"
            )}
            items={phBins}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
